type SponsorImage = {
  size: string;
  url: string;
};

export const getSponsorImageByPriority = (sponsorImages: SponsorImage[]) => {
  const sizePriority = ['XL', 'L', 'M', 'S', 'Icon'];
  return (
    sizePriority.map((size) => sponsorImages.find((img) => img.size === size)).find((img) => img) ||
    sponsorImages[0] ||
    null
  );
};
